module.exports = __webpack_public_path__ + "static/media/multiplex30.5e3a363a.png";